import React from "react";
import { createRoot } from "react-dom/client";
import { App } from "./ui/App";
import routeManifest from "./ui/route-manifest.json";
import "./ui/styles.css";

class ErrorBoundary extends React.Component<
  { children: React.ReactNode },
  { error: Error | null }
> {
  constructor(props: { children: React.ReactNode }) {
    super(props);
    this.state = { error: null };
  }

  static getDerivedStateFromError(error: Error) {
    return { error };
  }

  render() {
    if (this.state.error) {
      return (
        <main
          style={{
            padding: "48px 24px",
            fontFamily: "Fraunces, Georgia, serif",
            color: "#f8efe0",
            background: "#090806",
            minHeight: "100dvh"
          }}
        >
          <p
            style={{
              color: "#f28f3b",
              textTransform: "uppercase",
              fontSize: "0.78rem",
              fontWeight: 700,
              fontFamily: "Courier New, monospace"
            }}
          >
            SHADOW / Error
          </p>
          <h1 style={{ fontSize: "2.4rem", margin: "0 0 18px" }}>Something went wrong.</h1>
          <p style={{ color: "#d7c1aa", maxWidth: 520 }}>{this.state.error.message}</p>
          <button
            type="button"
            style={{
              marginTop: "24px",
              background: "#f28f3b",
              border: "0",
              borderRadius: "6px",
              color: "#160c06",
              cursor: "pointer",
              fontWeight: 800,
              padding: "14px 22px",
              fontFamily: "inherit"
            }}
            onClick={() => window.location.reload()}
          >
            Reload SHADOW
          </button>
        </main>
      );
    }
    return this.props.children;
  }
}

const root = document.getElementById("root");
if (!root) throw new Error("Missing #root");

const known = routeManifest.directLoadRoutes;
const knownPrefixes = routeManifest.prefixLoadRoutes;
const pathname = window.location.pathname;
const is404 =
  !known.includes(pathname) &&
  !knownPrefixes.some((prefix) => pathname.startsWith(prefix)) &&
  !pathname.startsWith("/assets/") &&
  !pathname.startsWith("/.well-known/");

if (is404) {
  createRoot(root).render(
    <main
      style={{
        padding: "48px 24px",
        fontFamily: "Fraunces, Georgia, serif",
        color: "#f8efe0",
        background: "#090806",
        minHeight: "100dvh"
      }}
    >
      <p
        style={{
          color: "#f28f3b",
          textTransform: "uppercase",
          fontSize: "0.78rem",
          fontWeight: 700,
          fontFamily: "Courier New, monospace"
        }}
      >
        SHADOW / 404
      </p>
      <h1 style={{ fontSize: "2.4rem", margin: "0 0 18px" }}>Page not found.</h1>
      <p style={{ color: "#d7c1aa" }}>This path does not exist inside SHADOW.</p>
      <a href="/" style={{ color: "#f28f3b" }}>
        Return to SHADOW →
      </a>
    </main>
  );
} else {
  createRoot(root).render(
    <React.StrictMode>
      <ErrorBoundary>
        <App />
      </ErrorBoundary>
    </React.StrictMode>
  );
}
